<template>
  <Head :title="t('page.title', {course: course.code})" />
  <edit-course-header :course="course" can-view-lti-link />
  <s-page-block size="md" class="flex flex-col gap-3">
    <template v-if="ltiCourseContext && linkedBy">
      {{
        t('information.linkedBy', {
          firstName: linkedBy.firstName,
          lastName: linkedBy.lastName,
          date: monthDayYear(ltiCourseContext.createdAt),
        })
      }}
      <s-btn v-if="can.delete" @click.prevent="deleteLink()" color="danger">
        {{ t('actions.delete') }}
      </s-btn>
    </template>
    <LtiCourseLinkInstructions v-else :can-create="can.create" :institution-linked />
  </s-page-block>
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import EditCourseHeader from '../../layouts/EditCourseHeader.vue';
import SPageBlock from '../../design-system/SPageBlock.vue';
import {Course} from '../../types/entities/course';
import {Head, router} from '@inertiajs/vue3';
import {route} from 'ziggy-js';
import {LtiCourseContext} from '../../types/entities/lti-course-context';
import SBtn from '../../design-system/SBtn.vue';
import LtiCourseLinkInstructions from './LtiCourseLinkInstructions.vue';
import {User} from '../../types/entities/user';
import {monthDayYear} from '../../format/dates.js';

const props = defineProps<{
  course: Course;
  ltiCourseContext: LtiCourseContext | null;
  linkedBy: User | null;
  institutionLinked: boolean;
  can: {
    create: boolean;
    delete: boolean;
  };
}>();

const {t} = useI18n();

const deleteLink = () =>
  router.delete(route('courses.lti-link.destroy', {course: props.course.id}));
</script>
<i18n>
{
  "en": {
    "page": {
      "title": "LTI Integration"
    },
    "actions": {
      "delete": "Remove Link"
    },
    "information": {
      "linkedBy": "Linked by {firstName} {lastName} on {date}"
    }
  },
  "fr": {
    "page": {
      "title": "Intégration LTI"
    },
    "actions": {
      "delete": "Supprimer le lien du cours"
    },
    "information": {
      "linkedBy": "Lié par {firstName} {lastName} le {date}"
    }
  }
}
</i18n>
